import { useOrganisation } from "@/features/select-organisation/api/get-my-organisation";
import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { CreateTagDto, PublicTag } from "@classview/shared-types";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const createRecordingTag = async ({
  orgId,
  recordingId,
  tag,
}: {
  orgId: string;
  recordingId: string;
  tag: CreateTagDto;
}): Promise<PublicTag> => {
  const response = await axiosClient.post(
    `/${orgId}/recordings/${recordingId}/tags`,
    tag,
  );
  return response.data;
};

function useCreateRecordingTag(
  recordingId: string,
  mutationOptions?: Partial<
    UseMutationOptions<PublicTag, HttpError, CreateTagDto>
  >,
) {
  const { organisation } = useOrganisation();
  return useMutation({
    mutationFn: (tag) =>
      createRecordingTag({
        orgId: organisation.id,
        recordingId,
        tag,
      }),
    ...mutationOptions,
  });
}

export { useCreateRecordingTag };
